import * as React from "react"
import {Layout} from "./Layout";
import {Project} from "../screens/project/Project";
import {graphql  } from "gatsby";
import {Seo} from "./Seo";
import {translate} from "../helpers/lang";
const ProjectPage = ({pageContext ,location , data }) => {

  const {lang, alternativePath} = pageContext ;
  const seoT = translate(lang ,data?.seoText?.nodes?.[0]?.seo );
  const titleT = translate(lang , data?.globalTitle.nodes[0].data); 
  const seo ={
    image :data?.seoImg?.nodes?.[0]?.childFile?.childImageSharp?.fixed?.src,
    seoTitle:seoT('title') ,
    title:titleT('title'),
    description:seoT('description'),
    lang
  }
  return (
    <Layout alternativePath={alternativePath} path={location.pathname}  lang ={lang}>
      <Seo {...seo}/>
      <Project PageData={data} lang={lang}/>
    </Layout>
  )
}

export default ProjectPage;


export const query = graphql`
  query postPage($engSlug: String ){
 bottomImg: allProjectsbottomImg(filter: {name: {eq: $engSlug}}) {
      nodes {
        childrenFile {
        childImageSharp {
           gatsbyImageData( 
            placeholder: BLURRED ,
               layout: FULL_WIDTH
          )
        }
        }  
      }
    }
      
     
  topImg:  allProjectstopImg(filter: {name: {eq: $engSlug}}) {
      nodes {
        childrenFile {
         childImageSharp {
          gatsbyImageData(
              layout: FULL_WIDTH
              
          )
        }
        } 
      }
    }
    
  seoImg :    allProjectsseoimg(filter: {name: {eq: $engSlug}}) {
      nodes {
        name
        childFile {
          childImageSharp {
            fixed {
              src
            }
          }
        }
      }
    }
    
   seoText :   allProjects(filter: {slug: {en: {eq: $engSlug}}})  { 
      nodes { 
        seo {
          description {
            en
            fr
          }
          title {
            en
            fr
          }
        }
      } 
  } 
  
  globalTitle:      allHome {
        nodes {
          data {
            title {
              en
              fr
            }
          }
        }
      }
    
  dataText:  allProjects(filter: {slug: {en: {eq: $engSlug}}}) {
      edges {
        node {
          id
          location {
            en
            fr
          }
          title_line_1 {
            fr
            en
          }
          title_line_2 {
            fr
            en
          }
          video
          year {
            en
            fr
          } 
            expertises {
              id
              subitems
        }
          credits
          client {
            en
            fr
          }
        }
      }
    }
  }
`